import React from 'react';
import { useTicketCount } from './useTicketCount';

const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '1.375rem',
    height: '1.375rem',
    padding: '0 0.375rem',
    borderRadius: '999px',
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1,
    color: '#fff',
    backgroundColor: '#e74c3c',
    cursor: 'pointer',
    textDecoration: 'none'
};

const TICKET_APP_URL = process.env.REACT_APP_TICKET_APP_URL;
const DEFAULT_SOURCE = process.env.REACT_APP_TICKET_APP_SOURCE_SLUG || 'remote-site';

export default function TicketBadge({ source = DEFAULT_SOURCE, siteId, systemId }) {
    const { count, loading } = useTicketCount({ source, siteId, systemId });

    if (loading || !count || count.open === 0 || !TICKET_APP_URL) return null;

    const params = new URLSearchParams({ source });
    if (siteId) params.set('site', siteId);
    if (systemId) params.set('system', systemId);

    return (
        <a
            href={`${TICKET_APP_URL}/tickets?${params}`}
            target="_blank"
            rel="noopener noreferrer"
            style={badgeStyle}
            title={`${count.open} open ticket${count.open !== 1 ? 's' : ''}`}
        >
            {count.open}
        </a>
    );
}
